import compatible from './script/compatible';
import utils from './script/utils';
import common from './script/common';
import store from './script/store';
import filter from './script/filter';
import action from './script/action';
import validate from './script/validate';
import components from './components';

/**
 * Vue扩展库
 */
export default {
	compatible,
	utils,
	common,
	store,
	filter,
	action,
	validate,
	components,
	install(Vue, config = {}) {

		/*初始化扩展库全局对象*/
		Vue.ext = {};

		/*安装扩展库插件集*/
		Object.entries(this).forEach(([k, v]) => k == 'install' || Vue.use(v, config[k]));

	}
}


// WEBPACK FOOTER //
// ./src/vue-ext/index.js